export function formatDate(
  value: string | Date | null | undefined,
  locale: string = "pt-PT",
  options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }
): string {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);

  if (isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat(locale, options).format(date);
}
